<i
  id="tooltipIcon"
  class="fa fa-question-circle-o"
  [pTooltip]="tooltipText | translate"
  tooltipPosition="top"
>
</i>
